import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function getTourInfo() {
  const { data } = await api.get("/tour-info");
  return data;
}

export async function createBooking(payload) {
  const { data } = await api.post("/bookings", payload);
  return data;
}

export async function createEnquiry(payload) {
  const { data } = await api.post("/enquiries", payload);
  return data;
}

export async function createContact(payload) {
  const { data } = await api.post("/contact", payload);
  return data;
}

export async function adminLogin(password) {
  const { data } = await api.post("/admin/login", { password });
  return data;
}

export async function fetchAdminData(password) {
  const headers = { "X-Admin-Password": password };
  const [bookings, enquiries, contact, vouchers, schoolBookings, corpBookings, reviews, yyBookings] = await Promise.all([
    api.get("/bookings", { headers }).then((r) => r.data),
    api.get("/enquiries", { headers }).then((r) => r.data),
    api.get("/contact", { headers }).then((r) => r.data),
    api.get("/vouchers", { headers }).then((r) => r.data).catch(() => []),
    api.get("/schools/bookings", { headers }).then((r) => r.data).catch(() => []),
    api.get("/corporate/bookings", { headers }).then((r) => r.data).catch(() => []),
    api.get("/reviews/admin", { headers }).then((r) => r.data).catch(() => []),
    api.get("/yesteryear/bookings", { headers }).then((r) => r.data).catch(() => []),
  ]);
  return { bookings, enquiries, contact, vouchers, schoolBookings, corpBookings, reviews, yyBookings };
}

// Blocked dates
export async function fetchBlockedDates() {
  const { data } = await api.get("/blocked-dates");
  return data;
}
export async function adminAddBlockedDate(password, date, reason) {
  const { data } = await api.post("/blocked-dates", { date, reason },
    { headers: { "X-Admin-Password": password } });
  return data;
}
export async function adminDeleteBlockedDate(password, date) {
  const { data } = await api.delete(`/blocked-dates/${date}`,
    { headers: { "X-Admin-Password": password } });
  return data;
}

// Public reviews
export async function submitReview(payload) {
  const { data } = await api.post("/reviews", payload);
  return data;
}
export async function fetchPublicReviews() {
  const { data } = await api.get("/reviews");
  return data;
}

// Admin reviews
export async function adminApproveReview(password, id, approved) {
  const { data } = await api.patch(`/reviews/admin/${id}`, { approved },
    { headers: { "X-Admin-Password": password } });
  return data;
}
export async function adminDeleteReview(password, id) {
  const { data } = await api.delete(`/reviews/admin/${id}`,
    { headers: { "X-Admin-Password": password } });
  return data;
}

// Vouchers
export async function purchaseVoucher(payload) {
  const { data } = await api.post("/vouchers/purchase", payload);
  return data;
}
export async function validateVoucher(code) {
  const { data } = await api.get(`/vouchers/validate/${encodeURIComponent(code)}`);
  return data;
}

// Yesteryear Talks
export async function fetchYesteryearOptions() {
  const { data } = await api.get("/yesteryear/options");
  return data;
}
export async function createYesteryearBooking(payload) {
  const { data } = await api.post("/yesteryear/bookings", payload);
  return data;
}
export async function fetchYesteryearBookingBySession(sessionId) {
  const { data } = await api.get(`/yesteryear/bookings/by-session/${sessionId}`);
  return data;
}

// Blog (public)
export async function fetchBlogPosts() {
  const { data } = await api.get("/blog/posts");
  return data;
}
export async function fetchBlogPost(slug) {
  const { data } = await api.get(`/blog/posts/${encodeURIComponent(slug)}`);
  return data;
}

// Blog (admin)
export async function adminListBlogPosts(password) {
  const { data } = await api.get("/blog/admin/posts", { headers: { "X-Admin-Password": password } });
  return data;
}
export async function adminCreateBlogPost(password, payload) {
  const { data } = await api.post("/blog/admin/posts", payload, { headers: { "X-Admin-Password": password } });
  return data;
}
export async function adminUpdateBlogPost(password, id, payload) {
  const { data } = await api.put(`/blog/admin/posts/${id}`, payload, { headers: { "X-Admin-Password": password } });
  return data;
}
export async function adminDeleteBlogPost(password, id) {
  const { data } = await api.delete(`/blog/admin/posts/${id}`, { headers: { "X-Admin-Password": password } });
  return data;
}
